import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import DashboardLayout from "./DashboardLayout";
import RoadmapSection from "./RoadmapSection";
import { clearAuthUser, getAuthUser } from "../utils/auth";

export default function RoadmapDashboard() {
  const navigate = useNavigate();
  const user = useMemo(() => getAuthUser(), []);

  const handleSignOut = () => {
    clearAuthUser();
    navigate("/login", { replace: true });
  };

  return (
    <DashboardLayout user={user} onSignOut={handleSignOut} activeKey="roadmap">
      {() => (
        <div className="space-y-6">
          <div className="text-sm text-white/50">
            Dashboard <span className="mx-2 text-white/30">›</span>  Investors Guide
          </div>

          <div className="p-0 sm:p-4 [&>section]:mt-0">
            <RoadmapSection />
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
